export const getToken = (): string | null => {
  // TODO: Make this configurable from the env
  const sessionToken = sessionStorage.getItem('oidc.user:https://identity-test.byggforsk.no:FigurApp');

  if (sessionToken) {
    const tokenObj = JSON.parse(sessionToken);

    const access_token = tokenObj?.access_token;

    return access_token;
  }

  return null;
};
